
<div class="task-management-container">

  <!-- Header -->
  <header class="clean-dashboard-header">
    <div class="header-main">
      <div class="header-left">
        <div class="header-icon">
          <i class="fa-solid fa-chart-pie"></i>
        </div>
        <div class="header-text">
          <h1>Task Management</h1>
          <p>Comprehensive task management overview and analytics</p>
        </div>
      </div>
    </div>
  </header>


  <div class="flex gap-6 h-full">

    <!-- ================= CALENDAR ================= -->

    <div class="calendar-section bg-white rounded-lg shadow-md p-6 w-80 flex-shrink-0">

      <!-- Calendar Header -->
      <div class="flex items-center justify-between mb-4">

        <button
          class="p-2 rounded-md hover:bg-gray-100"
          (click)="previousMonth()">

          <i class="fa-solid fa-chevron-left text-gray-600"></i>

        </button>

        <h2 class="text-lg font-semibold text-gray-800">
          {{ getMonthName() }} {{ currentYear }}
        </h2>

        <button
          class="p-2 rounded-md hover:bg-gray-100"
          (click)="nextMonth()">

          <i class="fa-solid fa-chevron-right text-gray-600"></i>

        </button>

      </div>


      <!-- Week Days -->
      <div class="grid grid-cols-7 gap-1 mb-2 text-xs font-semibold text-gray-600">
        <div class="text-center py-2">Sun</div>
        <div class="text-center py-2">Mon</div>
        <div class="text-center py-2">Tue</div>
        <div class="text-center py-2">Wed</div>
        <div class="text-center py-2">Thu</div>
        <div class="text-center py-2">Fri</div>
        <div class="text-center py-2">Sat</div>
      </div>


      <!-- Calendar Days -->
      <div class="grid grid-cols-7 gap-1">

        <div
          *ngFor="let day of getCalendarDays()"
          class="calendar-day text-center py-2 rounded-md cursor-pointer transition-colors"

          [ngClass]="{
            'text-gray-400': day === null,
            'bg-blue-600 text-white font-semibold': isSelected(day),
            'bg-blue-100 text-blue-800': isToday(day) && !isSelected(day),
            'hover:bg-gray-100': day !== null && !isSelected(day) && !isToday(day)
          }"

          (click)="selectDate(day)">

          {{ day }}

        </div>

      </div>


      <!-- Today Button -->
      <button
        class="w-full py-2 px-4 bg-gray-500 hover:bg-gray-600 rounded-md text-sm font-medium text-white mt-4"
        (click)="goToToday()">

        <i class="fa-solid fa-calendar mr-2"></i>
        Today

      </button>

    </div>


    <!-- ================= WORK LOGS ================= -->

    <div class="work-logs-section flex-1 bg-white rounded-lg shadow-md p-6 flex flex-col">

      <!-- Header -->
      <div class="flex items-center justify-between mb-6">

        <h2 class="text-xl font-semibold text-gray-800">
          Work Logs for {{ getSelectedDateString() }}
        </h2>

        <button
          pButton
          type="button"
          label="Add Work Log"
          icon="fa-solid fa-plus"
          class="p-button-primary"
          (click)="addSystem()">

        </button>

      </div>


      <!-- Empty State -->
      <div
        *ngIf="getWorkLogsForSelectedDate().length === 0"
        class="text-center py-12">

        <i class="fa-solid fa-clock text-gray-400 text-4xl mb-4"></i>

        <p class="text-gray-500 text-lg">
          No work logs yet for this date.
        </p>

      </div>


      <!-- Work Log Cards -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">

        <div
          *ngFor="let workLog of getWorkLogsForSelectedDate(); let i = index"
          class="worklog-card rounded-lg p-4 relative"

          [ngClass]="{
            'bg-pink-100': i % 4 === 0,
            'bg-purple-200': i % 4 === 1,
            'bg-green-100': i % 4 === 2,
            'bg-pink-200': i % 4 === 3
          }"

          pTooltip="Click to edit"
          tooltipPosition="top">


          <!-- Top Row -->
          <div class="flex items-start justify-between mb-2">

            <h3 class="font-semibold text-gray-800">
              Task ID: {{ workLog.id }}
            </h3>

            <div class="flex gap-3 text-lg">

              <i
                class="fa-solid fa-pen text-blue-600 cursor-pointer"
                (click)="onEditWorkLog(workLog); $event.stopPropagation()">

              </i>

              <i
                class="fa-solid fa-trash text-red-500 cursor-pointer"
                (click)="onDeleteWorkLog(workLog); $event.stopPropagation()">

              </i>

            </div>

          </div>


          <!-- Content -->
          <div class="text-sm text-gray-700 space-y-1">

            <p>
              <span class="font-semibold">Title:</span>
              {{ workLog.title }}
            </p>

            <p>
              <span class="font-semibold">Status:</span>
              {{ workLog.status }}
            </p>

            <p class="truncate">
              <span class="font-semibold">Description:</span>
              {{ workLog.description }}
            </p>

          </div>

        </div>

      </div>

    </div>

  </div>


  <!-- Dialog -->
  <app-reusable-dialog
    [(visible)]="showDialog"
    [config]="dialogConfig"
    [initialData]="formData"
    [viewMode]="viewMode"
    (onSubmit)="onSubmitWorkLog($event)"
    (onCancel)="onCancelDialog()"
    (onClose)="onCloseDialog()">
  </app-reusable-dialog>


  <!-- Toast -->
  <p-toast></p-toast>

</div>
```
